module.exports = __webpack_public_path__ + "img/homePIc1.927da938.png";